module.exports = __webpack_public_path__ + "img/firefox.be711e8f.svg";